enum DIMENSION {
  EXHAUSTION = "exhaustion",
  CYNICISM = "cynicism",
  PROFESSIONAL_EFFICACY = "professional_efficacy",
}

export default DIMENSION;
